module.exports = __webpack_public_path__ + "static/media/chevron-right.1f92c310.svg";